import ol from 'openlayers'
import moment from 'moment'
import IssuesModel from '../models/IssuesModel'

export const publicSetAnonymous = () => {
    return {
        type: 'ISSUE_SET_ANONYMOUS'
    }
}

export const issueChangeStep = (step) => {
    return {
        type: 'ISSUE_CHANGE_STEP',
        step: step
    }
}

export const issueMapCenter = (center, zoom, getLimits = false) => {
    return (dispatch) => {
        if (getLimits) {
            var coords = ol.proj.transform(center, 'EPSG:3857', 'EPSG:4326')

            // Validate coords
            if (coords) {
                IssuesModel.getLocationByLonLat(coords[0], coords[1], (caop) => {
                    dispatch({
                        type: 'ISSUE_MAP_SET_CENTER',
                        center,
                        zoom,
                        caop
                    })
                })
            }
        } else {
            dispatch({
                type: 'ISSUE_MAP_SET_CENTER',
                center,
                zoom
            })
        }
    }
}

export const issueUpdateForm = (formData, complete = false, error = '') => {
    return {
        type: 'ISSUE_UPDATE_FORM',
        formData,
        complete,
        error
    }
}

export const issueOpenForm = (formData) => {
    return {
        type: 'ISSUE_OPEN_FORM',
        formData
    }
}

export const issueStore = (formData) => {
    return (dispatch) => {
        IssuesModel.store(formData, (result) => {
            if (result.item) {
                formData['id'] = result.item.id
                formData['data_registo'] = result.item.data_registo
            }
            formData['complete'] = true
            dispatch(issueUpdateForm(formData, true, result.error))
        })
    }
}

export const issueSubmit = (formData) => {
    return (dispatch) => {
        formData.submitdate = moment().format('YYYY/MM/DD')
        IssuesModel.store(formData, (result) => {
            if (result.item) {
                formData['id'] = result.item.id
                formData['data_registo'] = result.item.data_registo
            }
            formData['complete'] = true
            dispatch(issueUpdateForm(formData, true, result.error))
        })
    }
}

export const issueResetForm = () => {
    return (dispatch) => {
        var formData = IssuesModel.dispense()
        dispatch(issueOpenForm(formData))
    }
}

/**
 * Use google maps geocoder
 * @param  {[type]} extent [description]
 * @return {[type]}        [description]
 */
export const gmapsGeocoder = (address) => {
    return (dispatch) => {
        const geocoder = new window.google.maps.Geocoder()
        geocoder.geocode({ 'address': address }, (results, status) => {
            if (
                (status === window.google.maps.GeocoderStatus.OK)
                && (results.length)
                && (results[0].geometry)
                && (results[0].geometry.location)
            ) {
                const lat = results[0].geometry.location.lat()
                const lng = results[0].geometry.location.lng()
                const coords = ol.proj.transform([lng, lat], 'EPSG:4326', 'EPSG:3857')

                // Validate coords
                coords && dispatch(issueMapCenter(coords, 14, false))
            }
        })
    }
}

/**
 * Use device geolocation
 * @param  {[type]} extent [description]
 * @return {[type]}        [description]
 */
export const getDeviceGeolocation = () => {
    return (dispatch) => {
        if (window.navigator.geolocation) {
            window.navigator.geolocation.getCurrentPosition((position) => {
                if (position.coords) {
                    const lat = position.coords.latitude
                    const lng = position.coords.longitude
                    const coords = ol.proj.transform([lng, lat], 'EPSG:4326', 'EPSG:3857')

                    // Validate coords
                    coords && dispatch(issueMapCenter(coords, 14))
                }
            })
        }
    }
}

export const publicLoadOwnIssues = () => {
    return (dispatch) => {
        IssuesModel.findOwn((result) => {
            dispatch({type: 'PUBLIC_ISSUES_LOAD', items: result})
        })
    }
}

export const publicLoadIssuesItem = (id) => {
    return (dispatch) => {
        if (!id) return dispatch(issueOpenForm(IssuesModel.dispense()))
        IssuesModel.find(id, (formData) => {
            dispatch(issueOpenForm(formData))
        })
    }
}

export const publicDelIssuesItem = (item) => {
    return (dispatch) => {
        IssuesModel.remove(item, (result) => {
            dispatch(publicLoadOwnIssues())
        })
    }
}

export const publicDelAttachItem = (item) => {
    return (dispatch) => {
        IssuesModel.removeAttach(item, (result) => {
            // Remove done
        })
    }
}

export const publicDelTempAttachItem = (item) => {
    return (dispatch) => {
        IssuesModel.removeTempAttach(item, (result) => {
            // Remove done
        })
    }
}

export const searchSubmit = (formData) => {
    return (dispatch) => {
        IssuesModel.search(formData, (result) => {
            dispatch(searchResults(result, true))
        })
    }
}

export const searchResetForm = () => {
    return (dispatch) => {
        setTimeout(() => {
            dispatch(searchResults([], true))
        }, 100)
    }
}

export const searchDelIssuesItem = (item) => {
    return (dispatch) => {
        IssuesModel.remove(item, (result) => {
            //dispatch(publicLoadOwnIssues())
        })
    }
}

export const searchSortResult = (config) => {
    return {
        type: 'SEARCH_SORT_RESULT',
        config
    }
}

export const searchUpdateForm = (formData) => {
    return {
        type: 'SEARCH_UPDATE_FORM',
        formData
    }
}

export const searchResults = (result, complete = false) => {
    return {
        type: 'SEARCH_RESULT',
        complete: complete,
        items: result
    }
}

export const publicLoadIssuesView = (id) => {
    return (dispatch) => {
        if (!id) return dispatch(issueOpenView(IssuesModel.dispense()))
        IssuesModel.find(id, (data) => {
            dispatch(issueOpenView(data))
        })
    }
}

export const publicLoadSimpleIssuesView = (id, code) => {
    return (dispatch) => {
        IssuesModel.findPublic(id, code, (data) => {
            dispatch(issueOpenView(data))
        })
    }
}

export const issueOpenView = (data) => {
    return {
        type: 'ISSUE_OPEN_VIEW',
        data
    }
}



// WEBPACK FOOTER //
// ./src/actions/issue.js